import { render, staticRenderFns } from "./HomeInvestigateDetail.vue?vue&type=template&id=1e46cf06&"
import script from "./HomeInvestigateDetail.vue?vue&type=script&lang=tsx&"
export * from "./HomeInvestigateDetail.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports